module.exports = __webpack_public_path__ + "img/aliance.faabaa5f.png";